export default __webpack_public_path__ + "static/media/cv.f9335960.png";